import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { ICrmFieldsFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters";
import ExcludeFilter from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/ExcludeFilter";
import { inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type { ICrmFilterOptions } from "../../types/options.dto";

export default class ExcludeByCrmFilter extends ExcludeFilter<ICrmFieldsFilterDto, ICrmFilterOptions> {
    constructor(deps: IFilterPanelBaseFilterDeps<ICrmFieldsFilterDto, ICrmFilterOptions>) {
        super(deps);
    }

    isValueEmpty(value?: ICrmFieldsFilterDto): boolean {
        return !value?.listFieldsFilters?.some((c) => !is.undefined(c.fieldValues));
    }

    getFullSelection(): ICrmFieldsFilterDto | undefined {
        return {
            inclusion: inclusionOptionMap.excludeOnly,
            listFieldsFilters: this.options.fields.map((c) => ({
                fieldName: c.fieldName,
                fieldValues: [],
            })),
        };
    }
}
